import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./Login";
import Register from "./Register";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/auth/api/v1/login" element={<Login />} />
        <Route path="/auth/api/v1/register" element={<Register />} />
        <Route path="/auth/api/v1/forgot-password" element={<ForgotPassword />} />
        <Route path="/auth/api/v1/reset-password" element={<ResetPassword />} />
        <Route path="*" element={<Navigate to="/auth/api/v1/login" />} />
      </Routes>
    </Router>
  );
}

export default App;